import { render, staticRenderFns } from "./CommissionAccount.vue?vue&type=template&id=a9ce3bcc&scoped=true&"
import script from "./CommissionAccount.vue?vue&type=script&lang=js&"
export * from "./CommissionAccount.vue?vue&type=script&lang=js&"
import style0 from "./CommissionAccount.vue?vue&type=style&index=0&id=a9ce3bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce3bcc",
  null
  
)

export default component.exports